import { FC } from 'react';

import { Heading, Text } from '@/components';
import { twMerge } from 'tailwind-merge';
import Link from 'next/link';

type ClassesTypes = {
  root?: string;
  list: {
    root: string;
  };
};

type PolicyPropTypes = {
  list?: Array<string>;
  heading?: string;
  classes?: ClassesTypes;
  toggleCartSidebar?: (...args: any) => void;
};

const PolicySection: FC<PolicyPropTypes> = ({
  list = [
    'Order cancellation is allowed only for 15 mins after order confirmation.',
  ],
  heading = 'Cancellation Policy',
  classes,
  toggleCartSidebar,
}) => {
  return (
    <div
      aria-label={heading}
      className={twMerge(
        `bg-section flex flex-col items-start gap-y-2 rounded-lg px-2 py-4`,
        classes?.root
      )}>
      <Heading as='h4' className='self-start text-sm'>
        {heading}
      </Heading>
      <ul className={twMerge(`list-none px-3`, classes?.list?.root)}>
        {list.map((el: string) => (
          <li key={el}>
            <Text className='p-0 text-sm'>{el}</Text>
          </li>
        ))}
      </ul>
      <Link
        className='pl-2 text-sm font-semibold text-fig hover:underline'
        href='/policies/returns-refunds-policy/'
        onClick={() => {
          if (toggleCartSidebar) {
            toggleCartSidebar(false);
          }
        }}>
        View our policies here
      </Link>
    </div>
  );
};

export default PolicySection;
